<template>
  <div>
    <OnboardingIndex
      title="Reset your password"
      submit_button_text="Send"
      :verification_running="action_running"
      @custom-submit="handle_enter_email"
    >
      <!-- Custom Form Content for Forgot Password -->
      <template v-slot:form-content>
        <div class="mb-3">
          
          <div>
            <input
              type="email"
              class="form-control form-control-lg text-xxs bg-light border-0 py-3"
              v-model.trim="email"
              id="email"
              placeholder="Enter your email here"
              required
            />
          </div>
        </div>
      </template>

      <!-- Extra content for "Login" link -->
      <template v-slot:signup-content>
        <div class="mt-4 text-center">
          <p class="mb-1">
            Remember your password?
            <a href="/" class="text-decoration-none text-primary">Login</a>
          </p>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
